import { render, staticRenderFns } from "./MemberAreaModulesContentHeader.vue?vue&type=template&id=32245bfe&scoped=true&"
import script from "./MemberAreaModulesContentHeader.vue?vue&type=script&lang=js&"
export * from "./MemberAreaModulesContentHeader.vue?vue&type=script&lang=js&"
import style0 from "./MemberAreaModulesContentHeader.vue?vue&type=style&index=0&id=32245bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32245bfe",
  null
  
)

export default component.exports